import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _Anually, _PayrollAccountant, _PayrollFactor } from "../../../../core/services/dataBean/EntityCatalogVdos";

import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { ValueTypeSelector } from "../ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";
import { FortnightTypeConstants } from "../PayrollFactor/FortnightTypeConstants";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { ElectronicPayrollCatalogSelect } from "./ElectronicPayrollCatalogSelect";
import { InfoForTaxReportingCatalogSelect } from "./InfoForTaxReportingCatalogSelect";
import { PayrollFactorVdosSelect } from "./PayrollFactorVdosSelect";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { InfoForTaxCertificateEditor } from "../InfoForTaxCertificate/InfoForTaxCertificateEditor";
import { FactorsList } from "./FactorsList/FactorsList";
import { ElectronicPayrollEditor } from "../ElectronicPayroll/ElectronicPayrollEditor";


export const PayrollFactorVdos = () => {

    const PayrollFactor = useDataBean(_PayrollFactor);
    const Anually = useDataBean(_Anually);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [Payroll, setPayroll] = useState<number>(null)
    const [valueclass, setValueclass] = useState<number>(null)
    const [fornight, setFornight] = useState<number>(null)
    const [modalconfig, setModalconfig] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modaldefinir, setModaldefinir] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [Payroll])

    const getLista = () => {

        PayrollFactor.instance.getPayrollFactorCatalog(valueclass, fornight).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)

                }
            }
        )

    }
    const create = () => {
        PayrollFactor.setBean({
            FortnightType: PayrollFactor.bean.FortnightType,
            ValueClassID: PayrollFactor.bean.ValueClassID
        });
        setModal({ ...modal, "view": true });
    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${PayrollFactor.bean.Name}`, "view": true }) } },
            { titulo: 'Definir Concepto de Certificado de Ingresos', icono: 'ri-wallet-fill', visible: single.canDelete(), evento: () => { setModaldefinir({ ...modaldefinir, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const head = [
        { title: 'ID', property: 'IDPayrollFactor', visible: true },

        { title: 'Nombre Concepto', property: 'Name', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Tipo Factor', property: 'FortnightTypeName', visible: true },
        { title: 'Clase Factor', property: 'ValueTypeName', visible: true },
        { title: 'Cuenta por Pagar', property: 'PaymentAccountantIDStrName', visible: true },
        { title: 'Cuenta Gasto', property: 'ExpensiveAccountantIDStrName', visible: true },
        { title: 'Cuenta Provisión', property: 'ProvisionAccountantIDStrName', visible: true },
        { title: 'Cuenta Reconicimiento Inicial', property: 'InitialRecAccountantIDStrName', visible: true },
        { title: 'Cuenta Gasto Vigencias Pasadas', property: 'PastValidityAccountantIDStrName', visible: true },
        { title: 'Rubro Presupuestal', property: 'FactorBudgetIDStrName', visible: true },
        { title: 'Nomina Electronica', property: 'ElectronicPayrollName', visible: true },
        { title: 'Descargar Archivo Plano', property: 'DownloadThirdFile', visible: true },
        { title: 'Usar Archivo Entidad', property: 'UseWelfareFile', visible: true },
        { title: 'Clase Archivo', property: 'ClassFileFactory', visible: true },
        { title: 'Exógena', property: 'InfoForTaxReportingName', visible: true },
        { title: 'Factor de Nómina Padre', property: 'IDPayrollFactorParent', visible: true },

    ]




    const editaItem = () => {
        //console.log(entailment.bean);
        PayrollFactor.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addAnnuallyPayrollFactor = () => {
        //console.log(entailment.bean);
        Anually.instance.addAnnuallyPayrollFactor(PayrollFactor.bean.IDPayrollFactor, Anually.bean.Year, Anually.bean.IDInfoForTaxCertificate).then(
            (resp: any) => {
                getLista();
                toast.success('Concepto Definido');
                setModaldefinir({ ...modaldefinir, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const verconfig = () => {
        setModalconfig({ ...modalconfig, "view": true });

    }

    return (
        <BasicPage titulo="Factores de Nómina">
            <div className="row">

                <div className="col-md-3">
                    <ValueTypeSelector label="Clase Factor" idSelector={valueclass} onChange={(e) => { setValueclass(e) }} />
                </div>
                <div className="col-md-3">
                    <FortnightTypeConstants idSelector={fornight} onChange={(e) => { setFornight(e) }} />
                </div>
                <div className="col-md-2 mt-4 p-2">

                    <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-bar-chart-grouped-fill" clase="btn btn-outline-primary btn-border" eventClick={verconfig} >
                        Configurar Factores Salariales por Vigencia
                    </BasicButton>

                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PayrollFactor.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre Concepto</label>
                                <input type="text" name="Name" className="form-control" value={PayrollFactor.bean.Name} onChange={PayrollFactor.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Mnemonic</label>
                                <input type="text" name="Mnemonic" className="form-control" value={PayrollFactor.bean.Mnemonic} onChange={PayrollFactor.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={PayrollFactor.bean.Code} onChange={PayrollFactor.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <FortnightTypeConstants label='Tipo Factor' idSelector={PayrollFactor.bean.FortnightType} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "FortnightType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <ValueTypeSelector label="Clase Factor" idSelector={PayrollFactor.bean.ValueClassID} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "ValueClassID": e }) }} />
                            </div>
                            <div className="col-md-6">

                                <SelectAccountantTree label="Cuenta por Pagar" jsonCode={PayrollFactor.bean.PaymentAccountantIDStr} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "PaymentAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">

                                <SelectAccountantTree label="Cuenta Gasto" jsonCode={PayrollFactor.bean.ExpensiveAccountantIDStr} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "ExpensiveAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">

                                <SelectAccountantTree label="Cuenta Provisión" jsonCode={PayrollFactor.bean.ProvisionAccountantIDStr} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "ProvisionAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">

                                <SelectAccountantTree label="Cuenta Reconocimiento Inicial" jsonCode={PayrollFactor.bean.InitialRecAccountantIDStr} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "InitialRecAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">

                                <SelectAccountantTree label="Cuenta Gasto Vigencias Pasadas" jsonCode={PayrollFactor.bean.PastValidityAccountantIDStr} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "PastValidityAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetID label="Rubro Presupuestal" jsonCode={PayrollFactor.bean.FactorBudgetIDStr} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "FactorBudgetIDStr": e.JsonCode }) }} edit={false} />
                            </div>
                            {/* <div className="col-md-6">
                                <ElectronicPayrollCatalogSelect label='Nomina Electronica' idSelector={PayrollFactor.bean.IDElectronicPayroll} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "IDElectronicPayroll": e }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <ElectronicPayrollEditor render={PayrollFactor.bean.ElectronicPayrollName} idSelector={PayrollFactor.bean.IDElectronicPayroll} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "IDElectronicPayroll": e.IDElectronicPayroll, "ElectronicPayrollName": e.PropertyName }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <InfoForTaxReportingCatalogSelect label='Exógena' idSelector={PayrollFactor.bean.IDInfoForTaxReporting} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "IDInfoForTaxReporting": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Factor de Configuración de Nómina</label>
                                <PayrollFactorVdosSelect render={PayrollFactor.bean.NamePayroll} idSelector={PayrollFactor.bean.IDPayrollFactorParent} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "IDPayrollFactorParent": e.IDPayrollFactor, "NamePayroll": e.Name }) }} label=" " returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Descargar Archivo Plano" estado={PayrollFactor.bean.DownloadThirdFile} eventChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "DownloadThirdFile": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Usar Archivo Entidad" estado={PayrollFactor.bean.UseWelfareFile} eventChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "UseWelfareFile": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <label>Clase Archivo</label>
                                <input type="text" name="ClassFileFactory" className="form-control" value={PayrollFactor.bean.ClassFileFactory} onChange={PayrollFactor.handleChange} />

                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaldefinir} updateModal={setModaldefinir} eventModal={addAnnuallyPayrollFactor}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Año</label>
                                <YearSelector tittle=" " value={Anually.bean.Year} onChange={(e) => { Anually.setBean({ ...Anually, "Year": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <InfoForTaxCertificateEditor render={Anually.bean.TaxCertificateName} idSelector={Anually.bean.IDInfoForTaxCertificate} onChange={(e) => { Anually.setBean({ ...Anually.bean, "IDInfoForTaxCertificate": e.IDInfoForTaxCertificate, "TaxCertificateName": e.SheetName }) }} returnType="Object" />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalconfig} updateModal={setModalconfig}>
                        <div className="row">
                            <FactorsList />
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}